var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-replace",
    d: "M8.942,3C4.908,3,1.627,6.588,1.627,11A8.583,8.583,0,0,0,2.6,14.989l-.78-.261a.623.623,0,0,0-.662.152.771.771,0,0,0-.2.708.7.7,0,0,0,.471.531L4.666,17.2l.449-3.641a.776.776,0,0,0-.15-.577.645.645,0,0,0-.5-.258.688.688,0,0,0-.673.64l-.1.8A7.018,7.018,0,0,1,2.957,11,6.27,6.27,0,0,1,8.942,4.455h.665V3Zm2.235.346-.519,1.342.615.283v0l.612.284L12.4,3.913ZM13.219,4.8,12.77,8.442a.763.763,0,0,0,.245.689.619.619,0,0,0,.67.1.724.724,0,0,0,.4-.593l.1-.8A7.018,7.018,0,0,1,14.928,11a6.27,6.27,0,0,1-5.986,6.545H8.277V19h.665c4.034,0,7.316-3.588,7.316-8a8.583,8.583,0,0,0-.974-3.989l.78.261a.623.623,0,0,0,.662-.152.771.771,0,0,0,.2-.708.7.7,0,0,0-.471-.531ZM6,16.749l-.519,1.338.612.283.616.283.515-1.342-.612-.283v0Z",
    transform: "translate(-0.942 -3)",
    fill: "#818181"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.dd4700937fc2a01f6e9636c1ed4fb769.svg";
export { ForwardRef as ReactComponent };